import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Row, Typography, Steps, Divider,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import routeLocations from '../../../utility/route-locations';
import { ViaLogo } from '../../../components/logo/ViaLogo';
import EditContactDetails from '../../secured/configure/company/EditContactDetails';
import EditVideoOptions from '../../secured/configure/inspection/EditVideoOptions';
import RegistrationWelcome from './RegistrationWelcome';
import useIsMobileSize from '../../../utility/hooks/useIsMobileSize';

const { Title } = Typography;
const { Step } = Steps;


/**
 * The first time setup wizard.
 * Allows the user to (optionally) set the important base data.
 * @param props The react props
 * @param props.history The react-router history object. Used to change location.
 */
export default function RegistrationWizard() {
  const history = useHistory();
  const isMobile = useIsMobileSize();
  const [currentStep, setCurrentStep] = useState(0);

  // Reset the user to the top of the screen on each step.
  useEffect(() => {
    window.scroll(0, 0);
  }, [currentStep]);

  return (
    <div className="app-registration-layout">
      <Row type="flex" align="middle" justify="center">
        <div className="app-registration-content" style={{ width: '100%', maxWidth: '800px' }}>
          <Row type="flex" justify="center" align="middle" style={{ height: '41px' }}>
            <Title level={1} className="app-registration-title"><FormattedMessage id="wizardStart" /></Title>
            <ViaLogo className="app-registration-logo" style={{ maxHeight: '50px', width: '150px' }} />
          </Row>
          <Row type="flex" justify="center" style={{ width: '100%', marginTop: '1.5em' }}>
            {
              // Unfortunately the steps don't work very well on mobile screens. So we hide them.
              !isMobile && (
                <Steps size="small" current={currentStep} progressDot>
                  <Step title={<div className="app-registration-step"><FormattedMessage id="registration" style={{ color: currentStep === 0 ? 'var(--component-primary-colour)' : 'black' }} /></div>} />
                  <Step title={<div className="app-registration-step"><FormattedMessage id="contactDetails" className="app-registration-step" style={{ color: currentStep === 1 ? 'var(--component-primary-colour)' : 'black' }} /></div>} />
                  <Step title={<div className="app-registration-step"><FormattedMessage id="videoOptions" /></div>} />
                  <Step title={<div className="app-registration-step"><FormattedMessage id="wizardHome" className="app-registration-step" style={{ color: currentStep === 3 ? 'var(--component-primary-colour)' : 'black' }} /></div>} />
                </Steps>
              )
            }
            <div className="steps-content" style={{ marginTop: '0.5em', width: '100%' }}>
              <Divider />
              {currentStep === 0 ? <RegistrationWelcome wizardNext={() => { setCurrentStep(1); }} /> : undefined}
              {currentStep === 1 ? <EditContactDetails wizard wizardNext={() => { setCurrentStep(2); }} /> : undefined}
              {currentStep === 2 ? <EditVideoOptions wizard wizardNext={() => history.push(routeLocations.dashboard)} /> : undefined}
            </div>
          </Row>
        </div>
      </Row>
    </div>
  );
}
